// 다국어 지원 시스템
const translations = {
  ko: {
    // UI 텍스트
    ui: {
      connected: '연결됨',
      disconnected: '연결 안됨',
      checking: '연결 확인 중...',
      home: '홈',
      newChat: '새 대화',
      sendMessage: '메시지를 입력하세요...',
      sendButton: '전송',
      shiftEnter: 'Shift + Enter로 줄바꿈, Enter로 전송',
      thinking: '생각 중...',
      language: '언어',
      korean: '한국어',
      english: 'English',
      // 이미지 상세보기
      imageViewer: {
        title: '이미지 상세보기',
        zoomIn: '확대',
        zoomOut: '축소',
        reset: '리셋',
        close: '닫기',
        zoomLevel: '확대율',
        instructions: '마우스 휠로 확대/축소, 드래그로 이동'
      }
    },
    // 메인 화면 텍스트
    main: {
      title: '스마트 물류플랫폼 AI와 대화를 시작하세요',
      subtitle: '아래 예시 질문을 클릭하거나 직접 질문을 입력해보세요.',
      additionalQuestions: '주안부평 스마트 물류플랫폼 관련 문의',
      // 예시 질문들
      examples: {
        platform: {
          title: '스마트 물류플랫폼',
          description: '물류 운영의 핵심 기능과 특징',
          query: '스마트 물류플랫폼의 주요 기능과 특징은 무엇인가요?'
        },
        operations: {
          title: '물류운영 시스템',
          description: '납품, 창고, 운송, 관제 시스템 통합',
          query: '물류납품, 물류창고, 물류운송, 물류관제 시스템은 어떻게 연동되나요?'
        },
        center: {
          title: '공동물류센터',
          description: '공동 운영의 효율성과 이점',
          query: '공동물류센터 운영 방식과 장점은 무엇인가요?'
        },
        platformTech: {
          title: '통합운영플랫폼',
          description: '디지털 기반 통합 운영 기술',
          query: '디지털기반 통합운영플랫폼의 핵심 기술은 무엇인가요?'
        },
        automation: '이용 혜택',
        iot: '컨설팅 신청 방법',
        optimization: '대상 기업',
        digitalTwin: '사업 개요'
      }
    },
    // 시스템 메시지
    system: {
      serverConnecting: '서버 연결 확인 중...',
      aiGenerating: 'AI가 답변을 생성 중입니다...',
      errorOccurred: '응답 생성 중 오류가 발생했습니다',
      serverUnavailable: '서버에 연결할 수 없습니다. 서버가 실행 중인지 확인해주세요.'
    }
  },
  en: {
    // UI 텍스트
    ui: {
      connected: 'Connected',
      disconnected: 'Disconnected',
      checking: 'Checking connection...',
      home: 'Home',
      newChat: 'New Chat',
      sendMessage: 'Type your message...',
      sendButton: 'Send',
      shiftEnter: 'Shift + Enter for new line, Enter to send',
      thinking: 'Thinking...',
      language: 'Language',
      korean: '한국어',
      english: 'English',
      // 이미지 상세보기
      imageViewer: {
        title: 'Image Detail View',
        zoomIn: 'Zoom In',
        zoomOut: 'Zoom Out',
        reset: 'Reset',
        close: 'Close',
        zoomLevel: 'Zoom Level',
        instructions: 'Mouse wheel to zoom, drag to move'
      }
    },
    // 메인 화면 텍스트
    main: {
      title: 'Start a conversation with Smart Logistics Platform AI',
      subtitle: 'Click on example questions below or type your own question.',
      additionalQuestions: 'Juanbupeong Smart Logistics Platform Related Inquiries',
      // 예시 질문들
      examples: {
        platform: {
          title: 'Smart Logistics Platform',
          description: 'Core functions and features of logistics operations',
          query: 'What are the main functions and features of the Smart Logistics Platform?'
        },
        operations: {
          title: 'Logistics Operations System',
          description: 'Integration of delivery, warehouse, transport, and control systems',
          query: 'How are logistics delivery, warehouse, transport, and control systems integrated?'
        },
        center: {
          title: 'Shared Logistics Center',
          description: 'Efficiency and benefits of shared operations',
          query: 'What are the operation methods and advantages of shared logistics centers?'
        },
        platformTech: {
          title: 'Integrated Operations Platform',
          description: 'Digital-based integrated operations technology',
          query: 'What are the core technologies of digital-based integrated operations platforms?'
        },
        automation: 'Benefits of Using',
        iot: 'Consulting Application',
        optimization: 'Eligible Companies',
        digitalTwin: 'Project Overview'
      }
    },
    // 시스템 메시지
    system: {
      serverConnecting: 'Checking server connection...',
      aiGenerating: 'AI is generating an answer...',
      errorOccurred: 'An error occurred while generating the response',
      serverUnavailable: 'Unable to connect to server. Please check if the server is running.'
    }
  },
  fr: {
    // UI 텍스트
    ui: {
      connected: 'Connecté',
      disconnected: 'Déconnecté',
      checking: 'Vérification de la connexion...',
      home: 'Accueil',
      newChat: 'Nouvelle conversation',
      sendMessage: 'Tapez votre message...',
      sendButton: 'Envoyer',
      shiftEnter: 'Maj + Entrée pour une nouvelle ligne, Entrée pour envoyer',
      thinking: 'Réflexion...',
      language: 'Langue',
      korean: '한국어',
      english: 'English',
      french: 'Français',
      japanese: '日本語',
      // 이미지 상세보기
      imageViewer: {
        title: 'Vue détaillée de l\'image',
        zoomIn: 'Zoom avant',
        zoomOut: 'Zoom arrière',
        reset: 'Réinitialiser',
        close: 'Fermer',
        zoomLevel: 'Niveau de zoom',
        instructions: 'Molette de la souris pour zoomer, glisser pour déplacer'
      }
    },
    // 메인 화면 텍스트
    main: {
      title: 'Commencez une conversation avec l\'IA de la plateforme logistique intelligente',
      subtitle: 'Cliquez sur les questions d\'exemple ci-dessous ou tapez votre propre question.',
      additionalQuestions: 'Demandes concernant la plateforme logistique intelligente Juanbupeong',
      // 예시 질문들
      examples: {
        platform: {
          title: 'Plateforme logistique intelligente',
          description: 'Fonctions et caractéristiques principales des opérations logistiques',
          query: 'Quelles sont les principales fonctions et caractéristiques de la plateforme logistique intelligente?'
        },
        operations: {
          title: 'Système d\'opérations logistiques',
          description: 'Intégration des systèmes de livraison, entrepôt, transport et contrôle',
          query: 'Comment les systèmes de livraison, entrepôt, transport et contrôle logistiques sont-ils intégrés?'
        },
        center: {
          title: 'Centre logistique partagé',
          description: 'Efficacité et avantages des opérations partagées',
          query: 'Quels sont les modes d\'exploitation et les avantages des centres logistiques partagés?'
        },
        platformTech: {
          title: 'Plateforme d\'exploitation intégrée',
          description: 'Technologie d\'exploitation intégrée basée sur le numérique',
          query: 'Quelles sont les technologies clés des plateformes d\'exploitation intégrées basées sur le numérique?'
        },
        automation: 'Avantages d\'utilisation',
        iot: 'Demande de conseil',
        optimization: 'Entreprises éligibles',
        digitalTwin: 'Aperçu du projet'
      }
    },
    // 시스템 메시지
    system: {
      serverConnecting: 'Vérification de la connexion au serveur...',
      aiGenerating: 'L\'IA génère une réponse...',
      errorOccurred: 'Une erreur s\'est produite lors de la génération de la réponse',
      serverUnavailable: 'Impossible de se connecter au serveur. Veuillez vérifier si le serveur est en cours d\'exécution.'
    }
  },
  ja: {
    // UI 텍스트
    ui: {
      connected: '接続済み',
      disconnected: '未接続',
      checking: '接続確認中...',
      home: 'ホーム',
      newChat: '新しい会話',
      sendMessage: 'メッセージを入力してください...',
      sendButton: '送信',
      shiftEnter: 'Shift + Enterで改行、Enterで送信',
      thinking: '考え中...',
      language: '言語',
      korean: '한국어',
      english: 'English',
      french: 'Français',
      japanese: '日本語',
      // 이미지 상세보기
      imageViewer: {
        title: '画像詳細表示',
        zoomIn: '拡大',
        zoomOut: '縮小',
        reset: 'リセット',
        close: '閉じる',
        zoomLevel: '拡大率',
        instructions: 'マウスホイールで拡大縮小、ドラッグで移動'
      }
    },
    // 메인 화면 텍스트
    main: {
      title: 'スマート物流プラットフォームAIとの会話を始めましょう',
      subtitle: '以下のサンプル質問をクリックするか、直接質問を入力してください。',
      additionalQuestions: '主安富平スマート物流プラットフォーム関連お問い合わせ',
      // 예시 질문들
      examples: {
        platform: {
          title: 'スマート物流プラットフォーム',
          description: '物流運営の核心機能と特徴',
          query: 'スマート物流プラットフォームの主要機能と特徴は何ですか？'
        },
        operations: {
          title: '物流運営システム',
          description: '配送、倉庫、輸送、管制システムの統合',
          query: '物流配送、物流倉庫、物流輸送、物流管制システムはどのように連動しますか？'
        },
        center: {
          title: '共同物流センター',
          description: '共同運営の効率性と利点',
          query: '共同物流センターの運営方式と利点は何ですか？'
        },
        platformTech: {
          title: '統合運営プラットフォーム',
          description: 'デジタル基盤統合運営技術',
          query: 'デジタル基盤統合運営プラットフォームの核心技術は何ですか？'
        },
        automation: '利用メリット',
        iot: 'コンサルティング申請方法',
        optimization: '対象企業',
        digitalTwin: '事業概要'
      }
    },
    // 시스템 메시지
    system: {
      serverConnecting: 'サーバー接続確認中...',
      aiGenerating: 'AIが回答を生成中です...',
      errorOccurred: '回答生成中にエラーが発生しました',
      serverUnavailable: 'サーバーに接続できません。バックエンドサーバーが実行中か確認してください。'
    }
  }
};

// 언어별 AI 시스템 프롬프트
const systemPrompts = {
  ko: `당신은 주어진 자료를 기반으로 유저의 질문에 답변하는 AI 어시스턴트입니다.

아래 관련 문서를 참고하여 질문에 정확한 한국어로 답변해주세요.

{context}

질문: {question}

답변 지침:
- 한국어 문법을 정확히 지켜주세요.
- 문장을 완전히 끝까지 작성해주세요.  
- 제공된 문서 내용 위주로 답변해주세요.
- 구체적이고 명확하게 답변해주세요.

답변:`,

  en: `You are an AI assistant that answers user questions based on the provided materials.

Please answer the question accurately in English using the relevant documents below as reference.

{context}

Question: {question}

Answer Guidelines:
- Use proper English grammar.
- Complete your sentences fully.
- Focus primarily on the content of the provided documents.
- Provide specific and clear answers.

Answer:`,
  fr: `Vous êtes un assistant IA qui répond aux questions des utilisateurs basées sur les documents fournis.

Veuillez répondre à la question avec précision en français en utilisant les documents pertinents ci-dessous comme référence.

{context}

Question: {question}

Directives de réponse:
- Respectez la grammaire française.
- Complétez vos phrases entièrement.
- Concentrez-vous principalement sur le contenu des documents fournis.
- Fournissez des réponses spécifiques et claires.

Réponse:`,
  ja: `あなたは提供された資料に基づいてユーザーの質問に答えるAIアシスタントです。

以下の関連文書を参考にして、質問に正確な日本語で答えてください。

{context}

質問: {question}

回答ガイドライン:
- 日本語の文法を正確に守ってください。
- 文章を完全に最後まで書いてください。
- 提供された文書の内容を中心に答えてください。
- 具体的で明確に答えてください。

回答:`
};

// 언어 변경 함수
const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      console.warn(`Translation missing for ${language}.${key}`);
      // 한국어로 폴백
      let fallbackValue = translations.ko;
      for (const fallbackKey of keys) {
        if (fallbackValue && typeof fallbackValue === 'object' && fallbackKey in fallbackValue) {
          fallbackValue = fallbackValue[fallbackKey];
        } else {
          return key; // 최종 폴백은 키 자체
        }
      }
      return fallbackValue;
    }
  }
  
  return value;
};

// 시스템 프롬프트 가져오기
const getSystemPrompt = (language) => {
  return systemPrompts[language] || systemPrompts.ko;
};

export { translations, systemPrompts, getTranslation, getSystemPrompt };
